import type {
  ActivityId,
  DeliverableId,
  FileId,
  OfferId,
  PackageId,
  ProjectId,
  ProjectServiceId,
  UserId,
} from '@mntn-dev/domain-types'
import type { EmptyObject } from 'type-fest'
import { register } from './register.ts'
import type {
  DashboardSortBy,
  SortDirection,
  UsersSortBy,
} from './types/sort-types.ts'
import type { DashboardPageTab, ProjectPageTab } from './types/tab-types.ts'

const routes = [
  // Unprotected

  register('/auth/logout').toRoute(),
  register('/login').toRoute<
    EmptyObject,
    { emailAddress?: string; returnTo?: string }
  >(),

  // Protected

  register('/')
    .protected()
    .toRoute(),

  register('/billing/cancel').protected().toRoute(),
  register('/billing/payment-methods').protected().toRoute(),
  register('/billing/add-method').protected().toRoute(),
  register('/billing/setup').protected().toRoute(),
  register('/billing/success').protected().toRoute(),

  register('/dashboard')
    .protected([['project:view']])
    .toRoute<
      EmptyObject,
      {
        search?: string
        sortBy?: DashboardSortBy
        sortDir?: SortDirection
        tab?: DashboardPageTab
      }
    >(),
  register('/offers').protected().toRoute(),
  register('/offers/:offerId').protected().toRoute<{ offerId: OfferId }>(),
  register('/packages').protected().toRoute(),
  register('/packages/:packageId')
    .protected()
    .toRoute<{ packageId: PackageId }>(),
  register('/packages/services').protected().toRoute(),
  register('/projects').protected().toRoute(),
  register('/projects/:projectId')
    .protected()
    .toRoute<
      { projectId: ProjectId },
      { tab?: ProjectPageTab; activityId?: ActivityId }
    >(),
  register('/projects/:projectId/services/:projectServiceId')
    .protected()
    .toRoute<{
      projectId: ProjectId
      projectServiceId: ProjectServiceId
    }>(),
  register('/projects/:projectId/match')
    .protected()
    .toRoute<{ projectId: ProjectId }>(),
  register('/projects/:projectId/match/maker/:userId').protected().toRoute<{
    projectId: ProjectId
    userId: UserId
  }>(),
  register('/projects/:projectId/browse').protected().toRoute<{
    projectId: ProjectId
  }>(),
  register('/projects/:projectId/review/post-production/:deliverableId')
    .protected()
    .toRoute<{
      projectId: ProjectId
      deliverableId: DeliverableId
    }>(),
  register('/projects/:projectId/files').protected().toRoute<{
    projectId: ProjectId
  }>(),
  register('/projects/:projectId/files/:fileId').protected().toRoute<{
    projectId: ProjectId
    fileId: FileId
  }>(),
  register('/projects/new').protected().toRoute(),
  register('/settings/user-profile').protected().toRoute(),
  register('/settings/agency-profile').protected().toRoute(),
  register('/users').toRoute<
    EmptyObject,
    { search?: string; sortBy?: UsersSortBy; sortDir?: SortDirection }
  >(),
  register('/users/:userId').protected().toRoute<{ userId: UserId }>(),
  register('/payment').protected().toRoute(),

  // Testing

  register('/foo')
    .protected([['project:view']])
    .toRoute<EmptyObject, { baz: string }>(),
  register('/foo/:fooId').toRoute<{ fooId: string }, { baz: string }>(),
  register('/foo/:fooId/bar/:barId').toRoute<
    { fooId: string; barId: string },
    { baz: string; qux: string; corge?: string }
  >(),
]

export default routes
